import { useEffect } from 'react';
/* Хук для блокировки прокрутки body при isActive === true*/
export const useBodyScrollLock = (isActive: boolean): void => {
    useEffect(() => {
        const className = 'stop-scrolling';
        if (typeof window === 'undefined' || !document?.body) {
            // Защита от SSR
            return;
        }
        if (isActive) {
            document.body.classList.add(className);
        } else {
            document.body.classList.remove(className);
        }
        return () => {
            document.body.classList.remove(className);
        };
    }, [isActive]);
};